<template>
  <div class="card mb-2">
    <div class="card-header bg-primary text-white d-flex">
      <a v-b-toggle="`collapse-project-events-card`" class="collapse-icon c-pointer">
        <font-awesome-icon class="when-opened" icon='caret-down' size="lg" />
        <font-awesome-icon class="when-closed fa-w-10" icon='caret-right' size="lg" />
      </a>
      <span class="font-weight-bold">Latest Events</span>
    </div>
    <b-collapse
      :id="`collapse-project-events-card`"
      v-model="showCollapse"
    >
      <div class="card-body">
      <LoadingSpinner v-if="loading" message ='Loading Latest Events' size = '1x'>
      </LoadingSpinner>
        <template v-if="!loading">
          <div v-if="!getLatestEvents || getLatestEvents.length === 0">
            No Events have been associated to this Project
          </div>
          <div v-for='entity in getLatestEvents'
            :key='entity.id'
            class="card listing-card">
            <div class="card-body row">
              <div class="col-md-3">
                <div class="list-header">
                  Event Type
                </div>
                <div class="list-details">
                  {{ getTypeString(entity) }}
                </div>
              </div>
              <div class="col-md-3">
                <div class="list-header">
                  Date
                </div>
                <div class="list-details">
                  {{ entity.date | dateString }}
                </div>
              </div>
              <div class="col-md-2">
                <div class="list-header">
                  Component
                </div>
                <div class="list-details">
                  {{ getComponentString(entity) }}
                </div>
              </div>
              <div class="col-md-3">
                <div class="list-header">
                  Added By
                </div>
                <div class="list-details">
                  {{ entity.createdByName }}
                </div>
              </div>
              <div class="col-md-1 d-flex justify-content-end align-self-center">
                <router-link
                   v-if="entity.serviceId"
                  :to="{ name: 'projectService', params: {
                  project_id: currentProject.id,
                  id: entity.serviceId }}"
                  class="btn btn-secondary btn-sm">
                  View
                </router-link>
                <router-link
                   v-else
                  :to="{ name: 'projectInstrument', params: {
                  project_id: currentProject.id,
                  id: entity.instrumentId }}"
                  class="btn btn-secondary btn-sm">
                  View
                </router-link>
              </div>
            </div>
          </div>
        </template>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { LookupModules } from '@/store/moduleConfig';
import CollapseControl from '@/mixins/CollapseControl';
import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default {
  name: 'ProjectEventsCard',
  components: {
    LoadingSpinner,
  },
  mixins: [CollapseControl],
  data() {
    return {
      showCollapse: false,
    };
  },
  created() {
    this.$store.dispatch(`${LookupModules.SERVICE_EVENT_TYPES.namespace}/fetchOptions`,
      LookupModules.SERVICE_EVENT_TYPES.url);
    this.$store.dispatch(`${LookupModules.INSTRUMENT_EVENT_TYPES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_EVENT_TYPES.url);
  },
  computed: {
    ...mapState('CurrentProject', {
      currentProject: state => state.currentProject,
      orderedEntities: (state) => {
        if (state.currentProject) {
          return state.currentProject.latestEvents;
        }
        return [];
      },
      loading: state => state.loading,
    }),
    ...mapGetters(LookupModules.SERVICE_EVENT_TYPES.namespace, {
      getServiceEventTypeName: 'getName',
    }),
    ...mapGetters(LookupModules.INSTRUMENT_EVENT_TYPES.namespace, {
      getInstrumentEventTypeName: 'getName',
    }),
    ...mapGetters('CurrentProject', {
      getLatestEvents: 'latestEvents',
    }),
  },
  methods: {
    getComponentString(entity) {
      if (entity.instrumentId) {
        return 'Instrument';
      }
      return 'Service';
    },
    getTypeString(entity) {
      if (entity.instrumentId) {
        return this.getInstrumentEventTypeName(entity.eventTypeId);
      }
      return this.getServiceEventTypeName(entity.eventTypeId);
    },
  },
};
</script>
